<script setup lang="ts">
/** Slides its content open and shut by animating to the measured height. */
defineProps<{ open: boolean }>();

function enter(element: Element) {
  const node = element as HTMLElement;
  node.style.height = "0px";
  void node.offsetHeight;
  node.style.height = `${node.scrollHeight}px`;
}

function afterEnter(element: Element) {
  (element as HTMLElement).style.height = "";
}

function leave(element: Element) {
  const node = element as HTMLElement;
  node.style.height = `${node.scrollHeight}px`;
  void node.offsetHeight;
  node.style.height = "0px";
}
</script>

<template>
  <Transition name="collapse" @enter="enter" @after-enter="afterEnter" @leave="leave">
    <div v-if="open" class="collapse"><slot /></div>
  </Transition>
</template>

<style scoped>
.collapse { overflow: hidden; }
.collapse-enter-active,
.collapse-leave-active { transition: height 280ms cubic-bezier(0.2, 0.7, 0.2, 1), opacity 200ms ease; }
.collapse-enter-from,
.collapse-leave-to { opacity: 0; }

@media (prefers-reduced-motion: reduce) {
  .collapse-enter-active,
  .collapse-leave-active { transition: none; }
}
</style>
